import * as React from 'react';
import { ReactElement, ReactNode } from 'react';
import { Colors, TextColorClasses } from '../../../types/colors';
import './style.css';

interface IProps {
  id?: string;
  children: ReactNode;
  level?: 'hero' | '1' | '2' | '3' | '4';
  color?: Colors;
  className?: string;
  style?: React.CSSProperties;
}

const Headline = ({
  id,
  children,
  level = 'hero',
  color = 'blue',
  className,
  ...props
}: IProps): ReactElement => {
  const textColorClass: TextColorClasses =
    `text-type-${color}` as TextColorClasses;

  let HeadlineEl;

  switch (level) {
    case 'hero':
      HeadlineEl = (
        <h1
          id={id}
          className={`headline headline--${level} ${textColorClass} ${className}`}
          {...props}>
          {children}
        </h1>
      );
      break;
    case '1':
      HeadlineEl = (
        <h1
          id={id}
          className={`headline headline--${level} ${textColorClass} ${className}`}
          {...props}>
          {children}
        </h1>
      );
      break;
    case '2':
      HeadlineEl = (
        <h2
          id={id}
          className={`headline headline--${level} ${textColorClass} ${className}`}
          {...props}>
          {children}
        </h2>
      );
      break;
    case '3':
      HeadlineEl = (
        <h3
          id={id}
          className={`headline headline--${level} ${textColorClass} ${className}`}
          {...props}>
          {children}
        </h3>
      );
      break;

    case '4':
      HeadlineEl = (
        <h4
          id={id}
          className={`headline headline--${level} ${textColorClass} ${className}`}
          {...props}>
          {children}
        </h4>
      );
      break;
  }

  return HeadlineEl;
};

export default Headline;
